import {
  ChargingStation,
  chargePointExistsInEconnector as checkExistsApi,
  linkChargingStation
} from '@infuse/api/e-connector/charging-station';
import { AxiosError } from 'axios';

import {
  CentralSystem,
  ConnectionType,
  LinkedCentralSystemType,
  OcppVersion
} from '@infuse/e-connector/central-system/domain';
import { createChargingStation } from '@infuse/api/e-connector/charging-station';
import { BasicAuthStatus, normalizeChargingStationForApi } from '@infuse/e-connector/charging-station/domain';

export const useCreateChargingStation = () => {
  async function chargePointExistsInEconnector(cpName: string): Promise<boolean> {
    try {
      return (await checkExistsApi({ id: cpName })).exists;
    } catch (err) {
      const status = (err as AxiosError).response?.status;
      if (status === 404) return false; // doesn't exist
      if (status === 403) return false; // ABAC: exists but no asset-level access
      throw err; // unexpected errors (5xx, network, etc.) propagate
    }
  }

  async function createStationInEconnector(id: string): Promise<ChargingStation> {
    const chargePointWithDefaults = {
      name: id,
      type: ConnectionType.WEBSOCKET,
      ocppVersion: OcppVersion.V16,
      useManualURI: false,
      useRequestHeader: false,
      omitSoapHeader: false,
      basicAuthStatus: BasicAuthStatus.NOT_REQUIRED,
      networkProfileId: 1
    };

    const chargePoint = await createChargingStation({}, normalizeChargingStationForApi(chargePointWithDefaults));
    return chargePoint as ChargingStation;
  }

  async function addDefaultLinkedCentralSystem(
    econnectorStation: ChargingStation,
    centralSystem: CentralSystem
  ): Promise<void> {
    const linkedCentralSystem = {
      id: econnectorStation.id,
      centralStationName: centralSystem.name,
      centralSystemName: centralSystem.name,
      link: true,
      type: LinkedCentralSystemType.MASTER,
      commandsAllowed: true,
      forwardBasicAuth: false,
      sessionAuthorizationAllowed: false
    };

    await linkChargingStation({ id: econnectorStation.id }, linkedCentralSystem);
  }

  return {
    chargePointExistsInEconnector,
    createStationInEconnector,
    addDefaultLinkedCentralSystem
  };
};
